import { MAX_FONT_SCALE, MIN_FONT_SCALE } from '../constants';

function restrictScale(scale: number) {
    if (scale > MAX_FONT_SCALE) {
        return MAX_FONT_SCALE;
    } else if (scale < MIN_FONT_SCALE) {
        return MIN_FONT_SCALE;
    }
    return scale;
}

function validateScale(scale: number) {
    return restrictScale(Math.round(scale));
}

export { validateScale };
